import { Copy } from 'lucide-react'
import cx from 'classnames'
import { ComponentProps } from 'react'
import { copyToClipboard } from '../utils'

type CodeSnippetProps = {
  code: string
  description?: string
  icon?: React.ReactNode
} & ComponentProps<'div'>

export function CodeSnippet({ code, description, icon, ...props }: CodeSnippetProps) {
  return (
    <div
      {...props}
      onClick={() => void copyToClipboard(code, description ?? 'code snippet')}
      className={cx(
        'group relative rounded-md border border-neutral-300 bg-neutral-50 p-4 pr-12 transition-colors hover:cursor-pointer active:border-neutral-500 active:bg-neutral-50',
        props.className
      )}
    >
      {icon ? (
        icon
      ) : (
        <Copy className="invisible absolute right-4 top-[0.8rem] h-6 w-6 text-neutral-900 opacity-0 transition-all group-hover:visible group-hover:opacity-100" />
      )}
      <pre className="truncate whitespace-pre text-xs">
        <code>{code.trim()}</code>
      </pre>
    </div>
  )
}
